export default {
  //en: "English",
  nl: "Nederlands (Dutch)",
  de: "Deutsch (German)",
  fr: "Français (French)"
};
